var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 24,
    viewBox: "0 0 39 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 38,
    height: 24,
    rx: 4,
    fill: "#E9E9E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7086 16.1015H15.5781L16.9107 8.37695H19.0411L17.7086 16.1015Z",
    fill: "#15195A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4299 8.56521C25.0097 8.40891 24.3432 8.23633 23.5191 8.23633C21.4151 8.23633 19.9336 9.28813 19.9245 10.7919C19.907 11.9013 20.9852 12.5175 21.7917 12.8875C22.6159 13.2655 22.8961 13.5122 22.8961 13.8492C22.8877 14.3667 22.2301 14.6052 21.6167 14.6052C20.7661 14.6052 20.3103 14.4822 19.6177 14.1943L19.3372 14.0709L19.0391 15.8049C19.5388 16.0183 20.4594 16.2077 21.4151 16.216C23.6506 16.216 25.1059 15.1805 25.1231 13.578C25.1316 12.6987 24.5623 12.0249 23.3348 11.4743C22.5897 11.1209 22.1334 10.8825 22.1334 10.5209C22.1421 10.1921 22.5193 9.85542 23.3605 9.85542C24.0531 9.83892 24.562 9.995 24.9475 10.1512L25.1401 10.2332L25.4299 8.56521Z",
    fill: "#15195A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2429 8.37695H30.8908L32.6096 16.1014H30.637C30.637 16.1014 30.4439 15.2139 30.3828 14.9426H27.6474C27.5683 15.148 27.2003 16.1014 27.2003 16.1014H24.9648L28.1294 9.01784C28.3486 8.51654 28.7347 8.37695 29.2429 8.37695ZM29.1116 11.2037C29.1116 11.2037 28.4365 12.9212 28.261 13.3649H30.0319C29.9443 12.9788 29.5408 11.1297 29.5408 11.1297L29.3919 10.4642C29.3292 10.6355 29.2386 10.8712 29.1774 11.0301C29.1359 11.1378 29.108 11.2103 29.1116 11.2037Z",
    fill: "#15195A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.34757 8.37695H9.77526C10.2399 8.39323 10.6169 8.53293 10.7396 9.02628L11.4845 12.5754L11.4847 12.5761L11.7127 13.6443L13.7992 8.37695H16.052L12.7032 16.0933H10.4503L8.55141 9.38137C7.89624 9.02225 7.14851 8.73342 6.3125 8.53304L6.34757 8.37695Z",
    fill: "#15195A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.f5ea9a099b7d98ca147cc6dcfb6f5677.svg";
export { ForwardRef as ReactComponent };